import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function ProfileSection() {
  const ref = useScrollReveal();

  return (
    <section className="w-full bg-white py-12 px-6">
      <div ref={ref} className="section-reveal max-w-2xl mx-auto">
        <p className="text-xs font-medium text-[#9A9A9A] tracking-[0.2em] uppercase mb-3">Profile</p>
        <div className="w-10 h-px bg-[#E0E0E0] mb-10" />

        <div className="space-y-5 text-[15px] md:text-base leading-[1.95] text-[#333333]">
          <p>
            Macを中心としたApple製品の活用法や、周辺機器、ガジェット、デスクアイテム、スマートホームまで。
            実際に使って感じたことを大切にしながら、暮らしに取り入れやすい情報を発信しています。
          </p>
          <p>
            博士号（PhD）をもつ視点も活かし、使い心地だけでなく、根拠や再現性にも配慮した
            丁寧で誠実なレビューを心がけています。
          </p>
          <p>
            ブログやSNSを通じて、あなたの暮らしに少しでも役立つきっかけをお届けできれば嬉しいです。
          </p>
        </div>
      </div>
    </section>
  );
}